import { Apollo } from "@/decorators";
import { User } from "../../store/store";

import CHAT_MESSAGES from "../../graphql/chat/ChatMessages.gql";
import CREATE_MESSAGE from "../../graphql/chat/CreateMessage.gql";
import CREATE_AUDIT_CHECK_MESSAGE from "../../graphql/chat/CreateAuditCheckMessage.gql";
import UPDATE_UNREAD_MESSAGE_COUNT from "../../graphql/UpdateChatUserUnreadMessageCount.gql";
import { NotificationBase } from "../NotificationBase";
import { Component } from "vue-facing-decorator";
import { Prop } from "vue-facing-decorator";
import { Watch } from "vue-facing-decorator";

@Component({
    emits: ["showMessageChanged", "messageSent"],
})
export class ChatBase extends NotificationBase {
    @Prop({ default: "" }) id: string;
    @Prop({ default: undefined }) inShowMessage: boolean;
    @Prop({ default: "" }) pushMessage: string;
    @Prop({ default: false }) create: boolean;
    @Prop({ default: "Discussion" }) chatTitle: string;
    @Prop({ default: "" }) chatSubtitle: string;
    @Prop({ default: "" }) label: string;
    @Prop({ default: false }) cardMode: boolean;
    @Prop({ default: true }) showSmartChat: boolean;
    @Prop({ default: null }) auditCheckAccountingPeriodKey: string;

    chat_ID = "";

    showMessage: boolean = false;

    messageToSend = "";

    showDiscussion = true;

    blinkBtn = true;

    get chatType(): string {
        // Don't forget to implement chatType function on child class
        debugger; // git-ignore
        return "";
    }

    get showDialog() {
        if (this.inShowMessage !== undefined) {
            return this.inShowMessage;
        }
        return !this.showMessage;
    }

    set showDialog(value) {
        if (this.inShowMessage !== undefined) {
            this.$emit("showMessageChanged", value);
        } else {
            this.showMessage = !value;
        }
    }

    get selectedCompany() {
        return this.$store.state.selected_company;
    }

    get chatUser() {
        if (this.currentUser?.id) {
            if (this.chat && this.chat.users) {
                for (const user of this.chat.users) {
                    if (user.user?.id === this.currentUser.id) {
                        return user;
                    }
                }
            }
        }
        return undefined;
    }

    get unreadMessageCount() {
        if (this.chatUser) {
            return this.chatUser.unreadMessageCount;
        }
        return 0;
    }

    set unreadMessageCount(value: number) {
        if (this.chatUser) {
            this.chatUser.unreadMessageCount = value;
        }
    }

    get messages() {
        if (this.chat) {
            console.log("this.chat.messages", this.chat.messages);
            return this.chat.messages;
        }
        return [];
    }

    get chatID() {
        // debugger;
        if (this.id) {
            return this.id;
        }
        return this.chat_ID;
    }

    set chatID(data: string) {
        this.chat_ID = data;
    }

    get currentUser(): User {
        return this.$store.state.user;
    }

    beforeMount() {
        if (this.cardMode === true) {
            this.showDialog = true;
        }
        this.addListener(["chatUser", "chatMessage"]);
    }

    beforeDestroy() {
        if (this.$apollo.queries && this.$apollo.queries.chat) {
            this.$apollo.queries.chat.stop();
        }
        this.removeListener();
    }

    onMessage(data) {
        if (!data) {
            return;
        }
        if (data.scope === "chatUser") {
            const updatedChatUser = data.payload;
            if (updatedChatUser) {
                if (updatedChatUser.id === data.id) {
                    if (this.showDialog && updatedChatUser.unreadMessageCount) {
                        this.updateMessageUnreadMessageCount(0);
                    } else if (this.chatUser) {
                        this.chatUser.unreadMessageCount = updatedChatUser.unreadMessageCount;
                    }
                }
            } else {
                debugger;
            }
        } else if (data.scope === "chatMessage") {
            if (
                data.payload?.chat?.id === this.chat?.id &&
                (data.action === "create" || data.action === "update")
            ) {
                if (data.action === "update") {
                    if (this.chat?.messages?.length) {
                        let index = this.chat.messages.findIndex((m) => m.id === data.id);
                        if (index !== -1) {
                            // this.chat.messages[index] = data.payload
                            this.chat.messages.splice(index, 1, data.payload);
                            this.updateScrollTop();
                        }
                    }
                } else if (data.action === "create") {
                    this.chat.messages.push(data.payload);
                    this.updateScrollTop();
                }
            }
        }
    }

    @Apollo({
        query: CHAT_MESSAGES,
        variables() {
            return {
                chatID: this.chatID || undefined,
                companyID: this.selectedCompany.id,
                chatType: this.chatType,
                auditCheckAccountingPeriodKey: this.auditCheckAccountingPeriodKey || undefined,
            };
        },
        specificResult({ data, loading, networkStatus }: any) {
            // result: ({ data, loading, networkStatus }: any) => {
            if (!loading) {
                if (data?.chats?.length) {
                    // console.log(data);
                    this.chat = data.chats[0];
                    this.setChatID(this.chat.id);
                    if (this.chatType === "COMPANY") {
                        this.updateMessageUnreadMessageCount(0);
                    }
                    // this.subscribe()
                    this.updateScrollTop();
                } else {
                    this.chat = null;
                    // this.unsubscribe()
                }
            }
        },
        skip() {
            if (!this.selectedCompany?.id) {
                return true;
            }
            if (this.chatType === "OBJECT") {
                return !this.id && !this.auditCheckAccountingPeriodKey;
            } else if (this.chatType === "COMPANY") {
                return this.id;
            }
            return true;
        },
    })
    chat = null;

    get disableSend() {
        if (!this.messageToSend) return true;
        if (!this.messageToSend.replace(/ /g, "")) return true;
        return false;
    }
    async send() {
        debugger;
        if (!this.disableSend) {
            if (this.auditCheckAccountingPeriodKey) {
                debugger;
                const chat = await this.$apollo.mutate({
                    mutation: CREATE_AUDIT_CHECK_MESSAGE,
                    variables: {
                        chatId: this.chatID,
                        companyId: this.selectedCompany.id,
                        message: this.messageToSend,
                        auditCheckAccountingPeriodKey: this.auditCheckAccountingPeriodKey,
                    },
                });
                this.setChatID(chat.data.createAuditCheckMessage.id);
            } else {
                debugger;
                const chat = await this.$apollo.mutate({
                    mutation: CREATE_MESSAGE,
                    variables: {
                        chatId: this.chatID,
                        chatType: this.chatType,
                        companyId: this.selectedCompany.id,
                        userId: this.currentUser.id,
                        message: this.messageToSend,
                        type: "",
                    },
                });
                this.setChatID(chat.data.createMessage.id);
            }
        }
    }

    discussionManager({ value }) {
        this.showDiscussion = value;
    }
    insertMessage(value: string) {
        this.messageToSend += value;
    }
    setChatID(chatId) {
        if (!this.chatID) {
            this.chatID = chatId;
        }
        this.messageToSend = "";
        this.$emit("messageSent", {
            chatId: this.chatID,
        });
    }

    setBlink({ value }) {
        this.blinkBtn = value;
    }

    // reduce() {
    //     this.showDialog = !this.showDialog;
    //     this.$emit("showMessageChanged");
    // }

    updateScrollTop() {
        setTimeout(() => {
            let htmlElement = this.$refs.chatMessages as HTMLElement;
            if (!htmlElement) {
                htmlElement = document.getElementById("chatMessages");
            }
            if (htmlElement) {
                htmlElement.scrollTop = htmlElement.scrollHeight - htmlElement.clientHeight;
            } else {
                // debugger;
            }
        }, 0);
    }

    // @Watch("inShowMessage")
    // onInShowMessageChanged(value, prevValue) {
    //     if (!this.showDialog && value === true && prevValue === false) {
    //         this.showDialog = true;
    //     }
    // }

    @Watch("cardMode")
    cardModeMoundted() {
        if (this.cardMode) {
            this.showDialog = true;
        } else {
            this.showDialog = false;
        }
    }

    @Watch("showDialog")
    onMinusChanged(value, prevValue) {
        if (value === false && prevValue === true) {
            this.updateMessageUnreadMessageCount(0);
        }
    }

    async updateMessageUnreadMessageCount(count) {
        if (this.chatUser?.id) {
            this.unreadMessageCount = count;
            await this.$apollo.mutate({
                mutation: UPDATE_UNREAD_MESSAGE_COUNT,
                variables: {
                    id: this.chatUser.id,
                    count: count,
                },
            });
        }
    }
}
